<!-- <app-page> -->
  <app-search-overlay [(visible)]="searchVisible" />
  <div class="home-page">
    <div class="buttons">
      <!-- <app-button -->
      <!--   class="search-btn" -->
      <!--   icon="pi pi-search" -->
      <!--   label="Search" -->
      <!--   [outlined]="globalService.theme() === 'dark'" -->
      <!--   (click)="searchVisible = true" -->
      <!-- /> -->
      <div
        class="search-btn box-shadow"
        (click)="searchVisible = true"
      >
        <i class="pi pi-search"></i>
        <span>Find Sequence</span>
      </div>
    </div>
    @if (globalService.emulatedUser()) {
      <app-status-badge class="width-100 emulate-badge" [status]="getEmulatedStatus()" />
    } 
    <!-- @if (currentSequence$ | async; as currentSequence) { -->
    <!--   <app-sequence-card class="card sequence-card" [sequence]="currentSequence" /> -->
    <!-- } -->
    <div class="accordions">
      <app-my-sequences class="card" />
      <app-about class="card" />
      @if (globalService.isAdmin()) {
      <app-admin class="card" />
      }
      <div class="version">v {{ version }}</div>
    </div>
  </div>
<!-- </app-page> -->
